import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = {
  key: 0,
  class: "hint"
}
const _hoisted_3 = {
  key: 1,
  class: "task-list"
}
const _hoisted_4 = { class: "hint" }
const _hoisted_5 = { class: "hint" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "section-head" }, [
      _createElementVNode("h2", { class: "section-title" }, "Ferramentas reservadas para este projeto")
    ], -1)),
    (_ctx.reservations.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Sem reservas."))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reservations, (entry) => {
            return (_openBlock(), _createElementBlock("div", {
              key: entry.id,
              class: "task-item"
            }, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.itemName(entry.itemId)), 1),
              _createElementVNode("div", _hoisted_4, "Tarefa: " + _toDisplayString(entry.taskId) + " | Quantidade: " + _toDisplayString(entry.quantity), 1),
              _createElementVNode("div", _hoisted_5, "Periodo: " + _toDisplayString(entry.reserveStartDate) + " ate " + _toDisplayString(entry.reserveEndDate), 1)
            ]))
          }), 128))
        ]))
  ]))
}